import React, { useEffect, useState } from 'react'
import Header from '../components/Header'
import axios from 'axios'
import { BaseUrl } from '../helper/Baseurl'
import { Loader } from 'react-overlay-loader'

function Contact() {
    const [data,setData] = useState()
    const fetchData = async () =>{
        await axios.get(`${BaseUrl.localBaseUrl}get-dynamic-page-content/Contact`).then((res)=>{
          setData(res.data.dynamic_page_content)
        })
      }
    
    
      useEffect(()=>{
    fetchData()
      },[])
      if(!data) return <Loader fullPage loading />
  return (
    <div className='bg-img'  >
        <Header data={data?.header}/>
     <div dangerouslySetInnerHTML={{__html: data?.content}} ></div>
    </div>
  )
}

export default Contact